import { LucideIcon } from "lucide-react";
import { Box, Flex, Heading, Text } from "@radix-ui/themes";

interface PageHeaderProps {
  title: string;
  description?: string | React.ReactNode;
  Icon?: LucideIcon;
  rightContent?: React.ReactNode;
}

export function PageHeader({
  title,
  description,
  Icon,
  rightContent,
}: PageHeaderProps & { rightContent?: React.ReactNode }) {
  return (
    <Box mb="4">
      <Flex justify="between" align="center">
        <Flex direction="column" gap="2">
          <Flex align="center" gap="3">
            {Icon && (
              <Box
                p="2"
                style={{
                  backgroundColor: "var(--accent-3)",
                  borderRadius: "var(--radius-3)",
                }}
              >
                <Icon
                  style={{
                    width: "24px",
                    height: "24px",
                    color: "var(--accent-9)",
                  }}
                />
              </Box>
            )}
            <Heading
              as="h1"
              size="6"
              weight="bold"
              style={{ textTransform: "capitalize" }}
            >
              {title}
            </Heading>
          </Flex>
          {description && (
            <Text size="2" color="gray">
              {description}
            </Text>
          )}
        </Flex>
        {rightContent && <Box>{rightContent}</Box>}
      </Flex>
    </Box>
  );
}
